__turbopack_context__.v({
  "anchor": "_3Q2sqa_anchor",
  "content": "_3Q2sqa_content",
  "popover-exit": "_3Q2sqa_popover-exit",
});
